// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"NMassiveActions_toggleButton__HCQBP","disabled":"NMassiveActions_disabled__2x49s"};